import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
export const REPORT_CUSTOM_KPIS = {
  [SUB_APPS.dealsWon]: ['SUM|hs_closed_won_count', 'SUM|raas_deal_win_rate'],
  [SUB_APPS.dealVelocity]: ['AVG|days_to_close'],
  [SUB_APPS.supportVolume]: ['SUM|count']
};